module.exports = {"340703005":"东郊","340703100":"西湖镇","340703198":"狮子山区虚镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340703.json
// module id = 1191
// module chunks = 0